import { adatTabla, alairas, datum, esc, ft, nemHivatalos } from './dokumentum-nyomtatas';
import { HONAPNEV } from './adatszolg.api';
import { BER_OPCIOK } from '../ber.opciok';

/*  BÉR – TB- ÉS ÁLLÁSKERESÉSI NYOMTATVÁNYOK (a Nyomtatványok katalógusához, ber-iratok.ts) – 2026-10-17.
 *
 *  A 2026-os állapot (a hivatalos forrásokból):
 *   - FOGLALKOZTATÁSI IGAZOLÁS (Flt. 36/A. §) – 2024. január 1-jétől ez váltotta az „igazolólap az álláskeresési
 *     járadék megállapításához” nyomtatványt. Az NFSZ 2026-os mintájának 1–31. rovata, a kitöltési útmutató
 *     szabályaival (a megszűnés negyedévét megelőző négy naptári negyedév, az érintett hónapok száma két tizedesre).
 *   - JÖVEDELEMIGAZOLÁS AZ EGÉSZSÉGBIZTOSÍTÁSI ELLÁTÁSHOZ – önálló hivatalos nyomtatványa nincs (a jövedelmet a
 *     kormányhivatal a NAV-nak bevallott járulékalapból veszi, Ebtv. 5/C. §). A lap a Kincstár kifizetőhelyi
 *     „Adatmegállapító lap” szerkezetét követi: irányadó időszak, havi bontás, kieső és jövedelemmel ellátott napok.
 *   - TÁPPÉNZIGÉNYLŐ (EB_IGBEJ_01) és FOLYAMATOS KERESŐKÉPTELENSÉG (EB_FOLYKK_01) – a kifizetőhellyel nem
 *     rendelkező foglalkoztató kizárólag elektronikusan, a SZÜF-ön nyújtja be (217/1997. Korm. r. 38. §). Papír
 *     minta nincs; ez a lap az űrlap rovatszámaival előtöltött KITÖLTŐ LAP – ebből gépelhető át, ill. ellenőrizhető.
 *
 *  Az adatok a dolgozói dossziéból (backend ber-adatszolg.js /dosszie, tortenet=1: az év előtti két év számfejtése
 *  és jelenléte is, a napi státuszokkal – 1 dolgozik, 2 szabadság, 3 beteg, 5 fizetés nélküli …).
 */

const n = (v: any) => { const x = Number(v); return Number.isFinite(x) ? x : 0; };
const ket = (v: number) => String(v).padStart(2, '0');
const iso = (y: number, m: number, d: number) => `${y}-${ket(m)}-${ket(d)}`;
const honapNapjai = (y: number, m: number) => new Date(Date.UTC(y, m, 0)).getUTCDate();
const napPlusz = (s: string, k: number) => { const d = new Date(s + 'T00:00:00Z'); d.setUTCDate(d.getUTCDate() + k); return d.toISOString().slice(0, 10); };
const napKulonbseg = (a: string, b: string) => Math.round((Date.parse(b + 'T00:00:00Z') - Date.parse(a + 'T00:00:00Z')) / 864e5);
const ho6 = (y: number, m: number) => y * 100 + m;
/** y-m-ből k hónappal arrébb: [év, hó]. */
const honapLepes = (y: number, m: number, k: number): [number, number] => { const i = y * 12 + (m - 1) + k; return [Math.floor(i / 12), (i % 12) + 1]; };
const nap10 = (v: any) => (v ? String(v).slice(0, 10) : '');
const felirat = (lista: string, v: any): string => (((BER_OPCIOK as any)[lista] || []) as any[]).find((x) => x.value === v)?.label || (v == null ? '' : String(v));
const pont = (mm = 40) => `<span class="pontok" style="min-width:${mm}mm"></span>`;
const ertek = (v: any, mm = 40) => (v != null && v !== '' ? `<b>${esc(v)}</b>` : pont(mm));
const pipa = (be: boolean | null) => `<span class="pipa">${be ? '✕' : ''}</span>`;

const STILUS = `<style>
  .tb { font-size: 9.2pt; line-height: 1.45; }
  .tb h1 { font-size: 13pt; text-align: center; margin: 0 0 2pt; }
  .tb .alcim { text-align: center; font-size: 8.4pt; color: #333; margin-bottom: 6pt; }
  .tb h2 { font-size: 9.8pt; margin: 8pt 0 3pt; padding: 2pt 4pt; background: #eef1f4; border-left: 2.5pt solid #3b4a5a; }
  .tb table.rov { width: 100%; border-collapse: collapse; }
  .tb table.rov td { border-bottom: .5pt solid #c9ced4; padding: 2.4pt 4pt; vertical-align: top; }
  .tb table.rov td.sz { width: 11mm; font-weight: 700; white-space: nowrap; }
  .tb table.rov td.m { width: 58%; }
  .tb table.rov td.e { font-weight: 700; }
  .tb .pontok { display: inline-block; border-bottom: .6pt dotted #111; height: 1em; vertical-align: -2pt; }
  .tb .pipa { display: inline-block; width: 3.6mm; height: 3.6mm; border: .7pt solid #111; vertical-align: -1pt; margin: 0 3pt 0 0;
    text-align: center; line-height: 3.4mm; font-size: 8pt; font-weight: 700; }
  .tb .megj { font-size: 7.8pt; color: #444; margin: 2pt 0; }
  .tb .figy { border: .8pt solid #b8860b; background: #fff8e1; padding: 3pt 5pt; font-size: 8pt; margin: 4pt 0; }
  .tb .alairas { margin-top: 14pt; }
</style>`;

type Rovat = [string, string, string];
function rovatok(sorok: Rovat[]): string {
  return `<table class="rov">${sorok.map(([sz, m, e]) => `<tr><td class="sz">${esc(sz)}</td><td class="m">${m}</td><td class="e">${e}</td></tr>`).join('')}</table>`;
}
const figy = (l: string[]) => (l.length ? `<div class="figy">${l.map(esc).join('<br>')}</div>` : '');

/* ─────────────────────────── közös adatok ─────────────────────────── */

const szfMind = (d: any): any[] => d.tortenet?.szamfejtes || d.szamfejtes || [];
const jelMind = (d: any): any[] => d.tortenet?.jelenlet || d.jelenlet || [];
/** A legkorábbi év, amelyre a dosszié számfejtést / jelenlétet hozott. */
const adatTol = (d: any, ev: number) => (d.tortenet ? ev - 2 : ev);

/** A napi státuszok egy térképen: 'YYYY-MM-DD' → státusz (a jelenlét „napok” nézetéből). */
function napTerkep(d: any): Record<string, number> {
  const t: Record<string, number> = {};
  for (const x of jelMind(d)) for (const [k, v] of Object.entries(x.napok || {})) if (v != null) t[k] = Number(v);
  return t;
}

/** A betegnapok időrendben, jelölve, melyik betegszabadság: a hónapban az első (betegszabadság órák / napi óra)
 *  nap – ugyanaz a sorrend, ahogy a számfejtés a betegszabadság-keretet felhasználja (ber-sulinform.js osszesit). */
function betegNapok(d: any, napiOra: number): { datum: string; betegszab: boolean }[] {
  const ki: { datum: string; betegszab: boolean }[] = [];
  for (const x of jelMind(d).slice().sort((a: any, b: any) => ho6(a.ev, a.ho) - ho6(b.ev, b.ho))) {
    const napok = Object.entries(x.napok || {}).filter(([, v]) => Number(v) === 3).map(([k]) => k).sort();
    const keret = Math.round(n(x.betegszabadsag_orak) / (napiOra || 8));
    napok.forEach((dt, i) => ki.push({ datum: dt, betegszab: i < keret }));
  }
  return ki;
}

/** Összefüggő keresőképtelenségi időszakok a betegnapokból: két betegnap egy időszak, ha a köztük lévő napokon
 *  nem dolgozott (dolgozik / kiküldetés / távmunka), és legfeljebb 4 nap a rés. A közbeeső szabadság, fizetés
 *  nélküli nap nem szakítja meg – az a mentesülés (6.7–6.8., ill. 3.2–3.3. rovat). */
function keresokeptelensegek(d: any, napiOra: number): { tol: string; ig: string; betegszabIg: string | null }[] {
  const t = napTerkep(d);
  const l = betegNapok(d, napiOra);
  const ki: { tol: string; ig: string; betegszabIg: string | null }[] = [];
  for (const b of l) {
    const utolso = ki[ki.length - 1];
    let egybe = false;
    if (utolso) {
      const res = napKulonbseg(utolso.ig, b.datum);
      egybe = res >= 1 && res <= 4;
      for (let k = 1; egybe && k < res; k++) { const st = t[napPlusz(utolso.ig, k)]; if ([1, 4, 7].includes(st)) egybe = false; }
    }
    if (egybe) { utolso.ig = b.datum; if (b.betegszab) utolso.betegszabIg = b.datum; }
    else ki.push({ tol: b.datum, ig: b.datum, betegszabIg: b.betegszab ? b.datum : null });
  }
  return ki;
}

/** Szabadság / fizetés nélküli napok (2, 5, 6) egy időszakon belül, összefüggő szakaszokra vonva. */
function mentesulesek(d: any, tol: string, ig: string): { tol: string; ig: string; jogcim: string }[] {
  const t = napTerkep(d);
  const ki: { tol: string; ig: string; jogcim: string }[] = [];
  const nev: Record<number, string> = { 2: 'szabadság', 5: 'fizetés nélküli szabadság', 6: 'munkavégzés alóli mentesülés' };
  for (let dt = tol; dt <= ig; dt = napPlusz(dt, 1)) {
    const st = t[dt];
    if (![2, 5, 6].includes(st)) continue;
    const u = ki[ki.length - 1];
    if (u && u.jogcim === nev[st] && napKulonbseg(u.ig, dt) <= 3) u.ig = dt; else ki.push({ tol: dt, ig: dt, jogcim: nev[st] });
  }
  return ki;
}

/** A megszűnt munkaviszony (a legkésőbb megszűnt); ha nincs, a fő jogviszony. */
function megszuntJv(d: any): any {
  const l = (d.jogviszonyok || []).filter((j: any) => j.veg).sort((a: any, b: any) => String(b.veg).localeCompare(String(a.veg)));
  return l.find((j: any) => j.tipus === 'munkaviszony') || l[0] || null;
}

/** Havi bér a szerződés szerint (órabérnél heti óraszám × 52 / 12 órával). */
function haviBer(j: any): { osszeg: number; megj: string } {
  if (!j?.alapber) return { osszeg: 0, megj: '' };
  if (j.ber_tipus === 'ora') {
    const orak = n(j.heti_oraszam || 40) * 52 / 12;
    return { osszeg: Math.round(n(j.alapber) * orak), megj: `órabér ${ft(j.alapber)} Ft × havi ${orak.toLocaleString('hu-HU', { maximumFractionDigits: 2 })} óra` };
  }
  return { osszeg: n(j.alapber), megj: j.ber_tipus === 'teljesitmeny' ? 'teljesítménybér – az alapbér' : '' };
}

/** Időtartam év / hónap / nap bontásban (a kezdő és a záró nap is beleszámít). */
function idotartam(tol: string, ig: string): string {
  if (!tol || !ig || ig < tol) return '';
  const [y1, m1, d1] = tol.split('-').map(Number); const [y2, m2, d2] = napPlusz(ig, 1).split('-').map(Number);
  let ev = y2 - y1, ho = m2 - m1, nap = d2 - d1;
  if (nap < 0) { ho--; const [py, pm] = honapLepes(y2, m2, -1); nap += honapNapjai(py, pm); }
  if (ho < 0) { ev--; ho += 12; }
  return `${ev} év ${ho} hónap ${nap} nap`;
}

const bankszamla = (v: any) => { const s = String(v || '').replace(/\D/g, ''); return s ? s.match(/.{1,8}/g)!.join('-') : ''; };

/* ─────────────────── 1. FOGLALKOZTATÁSI IGAZOLÁS (Flt. 36/A. §) ─────────────────── */

export function foglalkoztatasiFlt(u: any, d: any, ev: number): string {
  const a = d.alkalmazott;
  const j = megszuntJv(d);
  const hiany: string[] = [];
  if (!j) hiany.push('A dolgozónak nincs megszűnt jogviszonya – a foglalkoztatási igazolás a munkaviszony megszűnésekor adandó ki (Flt. 36/A. §).');
  const veg = nap10(j?.veg); const kezdet = nap10(j?.kezdet);
  const napiOra = n(j?.napi_oraszam) || 8;
  const jvSzf = szfMind(d).filter((s: any) => !j || s.jogviszony_id === j.id);

  //  16. a) a megszűnés negyedévét megelőző négy naptári negyedév (a megszűnés negyedéve nem számít bele).
  let negyedevTol = '', negyedevIg = '', jarulekalap = 0, honapok = 0;
  const honapSorok: string[][] = [];
  if (veg) {
    const vy = Number(veg.slice(0, 4)), vm = Number(veg.slice(5, 7));
    const qKezd = Math.floor((vm - 1) / 3) * 3 + 1;
    const [ty, tm] = honapLepes(vy, qKezd, -12); const [iy, im] = honapLepes(vy, qKezd, -1);
    negyedevTol = iso(ty, tm, 1); negyedevIg = iso(iy, im, honapNapjai(iy, im));
    if (ty < adatTol(d, ev)) hiany.push(`A négy negyedév ${ty}-ben kezdődik, a nyilvántartás ${adatTol(d, ev)}. januártól van betöltve – a megszűnés évét válaszd ki fent.`);
    const jel = jelMind(d);
    const hianyzoHo: string[] = [];
    for (let k = 0; k < 12; k++) {
      const [y, m] = honapLepes(ty, tm, k);
      const sorok = jvSzf.filter((s: any) => s.ev === y && s.ho === m);
      const alap = sorok.reduce((t: number, s: any) => t + n(s.tb_alap ?? s.brutto), 0);
      if (!sorok.length) {
        //  A jogviszony alatti, számfejtés nélküli hónap: a nyilvántartásból hiányzik (pl. a program bevezetése előtt).
        const elo = (!kezdet || kezdet <= iso(y, m, honapNapjai(y, m))) && (!veg || veg >= iso(y, m, 1));
        honapSorok.push([`${y}. ${HONAPNEV[m - 1]}`, '', '', elo ? 'nincs számfejtés' : '']);
        if (elo) hianyzoHo.push(`${y}. ${HONAPNEV[m - 1]}`);
        continue;
      }
      //  17. rovat: teljes hónap = 1; töredékhónap = a járulékalappal fedett napok / a hónap napjai
      //  (a jogviszony kezdete / vége, a fizetés nélküli szabadság és a táppénz napjai kiesnek).
      const hoTol = iso(y, m, 1), hoIg = iso(y, m, honapNapjai(y, m));
      const fedTol = kezdet > hoTol ? kezdet : hoTol, fedIg = veg < hoIg ? veg : hoIg;
      const fedett = fedIg >= fedTol ? napKulonbseg(fedTol, fedIg) + 1 : 0;
      const jx = jel.find((x: any) => x.ev === y && x.ho === m);
      const kieso = jx ? Math.round(n(jx.tappenz_napok) + n(jx.fizetes_nelkuli_orak) / napiOra) : 0;
      const arany = alap > 0 ? Math.min(1, Math.max(0, fedett - kieso) / honapNapjai(y, m)) : 0;
      jarulekalap += alap; honapok += Math.round(arany * 100) / 100;
      honapSorok.push([`${y}. ${HONAPNEV[m - 1]}`, ft(alap), arany ? arany.toFixed(2).replace('.', ',') : '0', kieso ? `${kieso} nap kieső` : '']);
    }
    if (hianyzoHo.length) hiany.push(`A négy negyedévből ${hianyzoHo.length} hónapra a jogviszony fennállt, de a nyilvántartásban nincs számfejtés (${hianyzoHo[0]}${hianyzoHo.length > 1 ? ` – ${hianyzoHo[hianyzoHo.length - 1]}` : ''}) – a 16. b) és a 17. rovatot a korábbi bérnyilvántartásból ki kell egészíteni.`);
  }

  const vy = veg ? Number(veg.slice(0, 4)) : ev;
  const vegHo = veg ? ho6(vy, Number(veg.slice(5, 7))) : 0;
  const ber = haviBer(j);
  const megszunesSorai = jvSzf.filter((s: any) => ho6(s.ev, s.ho) >= vegHo && vegHo);
  const vegkiel = megszunesSorai.reduce((t: number, s: any) => t + n(s.vegkielegites), 0);
  const megvalt = megszunesSorai.reduce((t: number, s: any) => t + n(s.szabadsagmegvaltas), 0);
  const tartozas = (d.letiltasok || []).filter((l: any) => l.aktiv);
  const evSor = jvSzf.filter((s: any) => s.ev === vy);
  const evOssz = (k: string) => evSor.reduce((t: number, s: any) => t + n(s[k]), 0);
  const bizTol = kezdet && kezdet > `${vy}-01-01` ? kezdet : `${vy}-01-01`;

  //  30. kifizetőhelynél: a megszűnést megelőző két évben folyósított táppénz (a jelenlét táppénznapjai).
  const tp = jelMind(d).filter((x: any) => n(x.tappenz_napok) > 0 && vegHo && ho6(x.ev, x.ho) <= vegHo && ho6(x.ev, x.ho) > vegHo - 200);
  //  31. a megszűnést megelőző három évben 30 napot meghaladó fizetés nélküli szabadság.
  const fn = jelMind(d).filter((x: any) => n(x.fizetes_nelkuli_orak) > 0 && vegHo && ho6(x.ev, x.ho) <= vegHo && ho6(x.ev, x.ho) > vegHo - 300);
  const fnNapok = Math.round(fn.reduce((t: number, x: any) => t + n(x.fizetes_nelkuli_orak), 0) / napiOra);
  //  „Nem vett igénybe” csak akkor jelölhető, ha a három év minden jogviszony alatti hónapjára van jelenléti adat.
  let jelHiany = 0;
  if (veg) {
    const [hy, hm] = honapLepes(vy, Number(veg.slice(5, 7)), -35);
    for (let k = 0; k < 36; k++) {
      const [y, m] = honapLepes(hy, hm, k);
      if (kezdet && kezdet > iso(y, m, honapNapjai(y, m))) continue;
      if (!jelMind(d).some((x: any) => x.ev === y && x.ho === m)) jelHiany++;
    }
  }
  const harom = !!veg && jelHiany === 0;
  const fnSzoveg = fn.map((x: any) => `${x.ev}. ${HONAPNEV[x.ho - 1]}: ${Math.round(n(x.fizetes_nelkuli_orak) / napiOra)} nap`).join('; ');

  return `${STILUS}<div class="tb">
    <h1>Foglalkoztatási igazolás</h1>
    <div class="alcim">a foglalkoztatás elősegítéséről és a munkanélküliek ellátásáról szóló 1991. évi IV. törvény 36/A. §-a szerint – az NFSZ 2026. évi mintája</div>
    ${figy(hiany)}
    <h2>Munkaadó adatai</h2>
    ${rovatok([
      ['1.', 'Neve', ertek(u.hivatalos_nev || u.nev)],
      ['2.', 'Székhelye', ertek(u.cim)],
      ['3.', 'Adószáma', ertek(u.adoszam)],
      ['4.', 'TEÁOR-szám', pont(30)],
      ['5.', 'Jogállásváltás esetén a jogelőd munkáltató adatai (csak az utolsó jogállásváltás)', ''],
      ['5.1.', 'Neve', pont()], ['5.2.', 'Székhelye', pont()], ['5.3.', 'Adószáma', pont(30)],
      ['5.4.', 'A munkavállaló által munkaviszonyban töltött idő időtartama', `${pont(10)} év ${pont(8)} hónap ${pont(8)} nap`],
      ['5.5.', 'A munkavállaló foglalkoztatási jogviszonyának megjelölése', pont()],
    ])}
    <h2>Munkavállaló adatai</h2>
    ${rovatok([
      ['6.', 'Neve', ertek(a.nev)], ['7.', 'Születési neve', ertek(a.szuletesi_nev || a.nev)], ['8.', 'Anyja neve', ertek(a.anyja_neve)],
      ['9.', 'Születési hely, idő', ertek([a.szul_hely, a.szul_ido ? datum(a.szul_ido) : ''].filter(Boolean).join(', '))],
      ['10.', 'TAJ-száma', ertek(a.taj)], ['11.', 'Adóazonosító jel', ertek(a.adoazonosito)],
    ])}
    <h2>Munkaviszonyra vonatkozó adatok</h2>
    ${rovatok([
      ['12.', 'A munkavállaló munkaviszonyának típusa (a megfelelő aláhúzandó)', 'határozott – határozatlan'],
      ['13.', 'Munkaköre (FEOR szerinti besorolásban)', ertek([j?.feor, j?.munkakor].filter(Boolean).join(' – '))],
      ['14.', 'Munkaviszony kezdete', ertek(kezdet ? datum(kezdet) : '')],
      ['15.', 'Munkaviszony vége (napig)', ertek(veg ? datum(veg) : '')],
      ['16.', 'A munkaadónál munkaviszonyban töltött időtartam', ertek(idotartam(kezdet, veg))],
      ['16. a)', 'A munkaviszony megszűnésének időpontját megelőző négy naptári negyedév kezdő napja, az időszak kezdete', ertek(negyedevTol ? datum(negyedevTol) : '')],
      ['16. b)', 'A négy naptári negyedévben elért társadalombiztosítási járulékalap összege (Ft)', ertek(veg ? ft(jarulekalap) : '')],
      ['17.', 'A négy naptári negyedévben azon hónapok száma, amelyekben a munkavállalónak volt járulékalapja (érintett hónapok száma)',
        ertek(veg ? honapok.toFixed(2).replace('.', ',') : '')],
      ['18.', 'A munkavállalónak a munkaviszony megszűnésekor, megszüntetésekor irányadó munkabére (Ft) – az összeg bruttó/nettó',
        ber.osszeg ? `<b>${ft(ber.osszeg)} Ft, bruttó</b>${ber.megj ? `<div class="megj">${esc(ber.megj)}</div>` : ''}` : pont()],
      ['19.', 'Egyéb járandóságai, távolléti díja, a munkavállalót megillető végkielégítés összege, ha arra jogosult volt (Ft)',
        vegkiel || megvalt ? `<b>${ft(vegkiel + megvalt)} Ft</b><div class="megj">${[vegkiel ? `végkielégítés ${ft(vegkiel)} Ft` : '', megvalt ? `szabadságmegváltás ${ft(megvalt)} Ft` : ''].filter(Boolean).join(', ')}</div>` : pont()],
      ['20.', 'A munkabérből határozat vagy jogszabály alapján levonandó tartozása',
        `${pipa(tartozas.length > 0)}van &nbsp; ${pipa(tartozas.length === 0)}a jogviszony megszűnésekor munkabérét tartozás nem terheli`],
      ['21.', 'Tartozás esetén annak jogosultja', tartozas.length ? `<b>${esc(tartozas.map((l: any) => [l.jogosult, l.ugyszam].filter(Boolean).join(', ')).join('; '))}</b>` : '—'],
      ['22.', 'A munkaviszony megszüntetésének vagy megszűnésének jogcíme', ertek(j?.kilepes_ok)],
      ['23.', 'A munkaadó által kiadott apasági szabadság vagy szülői szabadság tartama (a korábbi munkaadó által kiadott apasági szabadsággal együtt)', pont()],
      ['24.', 'A tárgyévben fennállt biztosítási idő kezdetének időpontja', ertek(veg ? datum(bizTol) : '')],
      ['25.', 'A tárgyévben fennállt biztosítási idő végének időpontja', ertek(veg ? datum(veg) : '')],
      ['26.', 'A tárgyévre, illetve a tárgyévtől eltérő időre levont járulékok összege (Ft)', ertek(evSor.length ? ft(evOssz('tb_jarulek')) : '')],
      ['27.', 'Az egyes járulékokból érvényesített családi járulékkedvezmény összege (Ft)', ertek(evSor.length ? ft(evOssz('csaladi_jarulekkedv')) : '')],
      ['28.', 'A munkaadó által az adóévben kifizetett jövedelem összesen (Ft)', ertek(evSor.length ? ft(evOssz('brutto')) : '')],
      ['29.', 'A levont adóelőlegek összege összesen (Ft)', ertek(evSor.length ? ft(evOssz('szja')) : '')],
      ['30.', 'Társadalombiztosítási kifizetőhellyel rendelkező munkaadónál: a megszűnést közvetlenül megelőző két éven belül folyósított táppénz, baleseti táppénz, CSED, örökbefogadói díj és GYED időtartama',
        u.kifizetohelyi ? (tp.length ? `<b>táppénz: ${esc(tp.map((x: any) => `${x.ev}. ${HONAPNEV[x.ho - 1]} ${n(x.tappenz_napok)} nap`).join('; '))}</b>` : '<b>nem volt</b>') : '— (a munkaadó nem kifizetőhely)'],
    ])}
    <h2>31. A munkaviszony megszűnését megelőző három évben</h2>
    <div>${pipa(harom && fnNapok <= 30)}a munkavállaló nem vett igénybe 30 napot meghaladó fizetés nélküli szabadságot.</div>
    <div>${pipa(fnNapok > 30)}a munkavállaló igénybe vett 30 napot meghaladó időtartamú fizetés nélküli szabadságot.</div>
    <div style="margin-top:3pt">Kezdete: ${pont(32)} &nbsp; vége: ${pont(32)}</div>
    ${fnSzoveg ? `<div class="megj">A nyilvántartott fizetés nélküli napok: ${esc(fnSzoveg)}.</div>` : ''}
    ${veg && jelHiany ? `<div class="megj">A három évből ${jelHiany} hónapra nincs jelenléti adat a nyilvántartásban – a választ a korábbi nyilvántartás alapján kell megjelölni.</div>` : ''}
    <div style="margin-top:3pt">Ha az Flt. 25. § (4) bekezdésében meghatározott esetben került rá sor, a jogcíme:</div>
    <div>${pipa(false)}háromévesnél (gyermekgondozást segítő ellátásnál tizennégy évesnél) fiatalabb gyermek gondozása, vagy tizenkét évesnél fiatalabb beteg gyermek otthoni ápolása</div>
    <div>${pipa(false)}hozzátartozó ápolása &nbsp; ${pipa(false)}önkéntes tartalékos katonai tényleges szolgálatteljesítés</div>
    ${honapSorok.length ? `<h2>A 16. b) és a 17. rovat számítása (a kitöltő munkalapja, nem része az igazolásnak)</h2>
      ${adatTabla(['Hónap', 'Járulékalap (Ft)', 'Érintett hónap', 'Megjegyzés'], honapSorok, [1, 2], ['Összesen', ft(jarulekalap), honapok.toFixed(2).replace('.', ','), ''])}
      <div class="megj">A töredékhónap a járulékalappal fedett napok és a hónap napjainak hányadosa (a jogviszony kezdete/vége, a táppénz és a fizetés nélküli szabadság napjai kiesnek) – ellenőrizendő.</div>` : ''}
    <div class="megj">Kiadása: munkáltatói felmondásnál az utolsó munkában töltött napon, egyébként a megszűnést követő 5 munkanapon belül; elektronikusan, a munkavállaló kérésére papíron.</div>
    ${alairas()}
  </div>`;
}

/* ─────────── 2. JÖVEDELEMIGAZOLÁS (az Adatmegállapító lap szerkezetével) ─────────── */

/** A jogosultság első napja: a hónap első betegnapja, ha van; különben a hónap első napja. */
function jogosultsagNapja(d: any, ev: number, ho: number, napiOra: number): { datum: string; becsult: boolean } {
  const kk = keresokeptelensegek(d, napiOra).find((k) => k.ig >= iso(ev, ho, 1) && k.tol <= iso(ev, ho, honapNapjai(ev, ho)));
  if (kk) {
    //  A táppénz a betegszabadság lejárta utáni naptól jár.
    return { datum: kk.betegszabIg ? napPlusz(kk.betegszabIg, 1) : kk.tol, becsult: false };
  }
  return { datum: iso(ev, ho, 1), becsult: true };
}

export function ebJovedelem(u: any, d: any, ev: number, ho: number): string {
  const a = d.alkalmazott;
  const j = (d.jogviszonyok || []).slice().sort((x: any, y: any) => String(y.kezdet || '').localeCompare(String(x.kezdet || '')))
    .find((x: any) => String(x.kezdet || '') <= iso(ev, ho, honapNapjai(ev, ho))) || null;
  const napiOra = n(j?.napi_oraszam) || 8;
  const jog = jogosultsagNapja(d, ev, ho, napiOra);
  const jy = Number(jog.datum.slice(0, 4)), jm = Number(jog.datum.slice(5, 7));
  //  Irányadó időszak: a biztosítás első napjától a jogosultságot megelőző harmadik hónap utolsó napjáig,
  //  legkorábban a jogosultságot megelőző év január 1-jétől (Ebtv. 48. §; a Kincstár 2026-os tájékoztatója).
  const [iy, im] = honapLepes(jy, jm, -3);
  const igN = iso(iy, im, honapNapjai(iy, im));
  const kezdet = nap10(j?.kezdet);
  const tolN = kezdet && kezdet > `${jy - 1}-01-01` ? kezdet : `${jy - 1}-01-01`;
  const hiany: string[] = [];
  if (jog.becsult) hiany.push(`A hónapban nincs rögzített betegnap – a jogosultság első napjának ${datum(jog.datum)} van véve; a valódi napot írd be, és a lapot a jó hónapra nyomtasd.`);
  if (jy - 1 < adatTol(d, ev)) hiany.push('Az irányadó időszak a betöltött nyilvántartás előtt kezdődik – a hiányzó hónapok üresek.');
  const jel = jelMind(d); const szf = szfMind(d);
  const sorok: string[][] = [];
  let osszNap = 0, osszJov = 0, osszKieso = 0;
  const havi: { napok: number; jov: number }[] = [];
  let hianyzoHo = 0;
  if (igN >= tolN) {
    for (let [y, m] = [Number(tolN.slice(0, 4)), Number(tolN.slice(5, 7))]; ho6(y, m) <= ho6(iy, im); [y, m] = honapLepes(y, m, 1)) {
      const hoTol = iso(y, m, 1) < tolN ? tolN : iso(y, m, 1);
      const hoIg = iso(y, m, honapNapjai(y, m)) > igN ? igN : iso(y, m, honapNapjai(y, m));
      const napok = napKulonbseg(hoTol, hoIg) + 1;
      const jx = jel.find((x: any) => x.ev === y && x.ho === m);
      const kieso = jx ? Math.min(napok, Math.round(n(jx.tappenz_napok) + n(jx.fizetes_nelkuli_orak) / napiOra)) : 0;
      const s = szf.filter((x: any) => x.ev === y && x.ho === m);
      const jov = s.reduce((t: number, x: any) => t + n(x.tb_alap ?? x.brutto), 0);
      const ellatott = s.length ? napok - kieso : 0;
      if (!s.length && (!kezdet || kezdet <= hoIg)) hianyzoHo++;
      osszNap += ellatott; osszJov += jov; osszKieso += kieso; havi.push({ napok: ellatott, jov });
      sorok.push([`${datum(hoTol)} – ${datum(hoIg)}`, kieso ? String(kieso) : '', s.length ? String(ellatott) : '', s.length ? ft(jov) : '']);
    }
  }
  if (hianyzoHo) hiany.push(`Az irányadó időszakból ${hianyzoHo} hónapra a jogviszony fennállt, de a nyilvántartásban nincs számfejtés – a jövedelmet a korábbi bérnyilvántartásból ki kell egészíteni (a tájékoztató számítás ezek nélkül készült).`);
  //  Tájékoztató napi átlag: az időszak végéről visszafelé 180 naptári napnyi jövedelem (ha van annyi), különben az egész.
  let n180 = 0, j180 = 0;
  for (const h of havi.slice().reverse()) { if (n180 >= 180) break; n180 += h.napok; j180 += h.jov; }
  const ber = haviBer(j);
  return `${STILUS}<div class="tb">
    <h1>Jövedelemigazolás</h1>
    <div class="alcim">az egészségbiztosítási pénzbeli ellátás (táppénz, csecsemőgondozási díj, gyermekgondozási díj) megállapításához – a kifizetőhelyi Adatmegállapító lap szerkezetével</div>
    ${nemHivatalos('Önálló hivatalos nyomtatványa nincs: a kormányhivatal a NAV-nak bevallott járulékalapból számol (Ebtv. 5/C. §). Ez a lap a foglalkoztató nyilvántartásából készült összesítő a kérelemhez, az új munkáltatónak vagy a kormányhivatal megkeresésére.')}
    ${figy(hiany)}
    <h2>Adatok</h2>
    ${rovatok([
      ['', 'Foglalkoztató', ertek([u.hivatalos_nev || u.nev, u.adoszam].filter(Boolean).join(', '))],
      ['', 'A biztosított neve, TAJ-száma', ertek([a.nev, a.taj].filter(Boolean).join(', '))],
      ['', 'Születési hely, idő; anyja neve', ertek([a.szul_hely, a.szul_ido ? datum(a.szul_ido) : '', a.anyja_neve].filter(Boolean).join(', '))],
      ['', 'A jelenlegi biztosítási jogviszony kezdete', ertek(kezdet ? datum(kezdet) : '')],
      ['', 'A biztosítási jogviszony megszűnése', ertek(j?.veg ? datum(j.veg) : 'fennáll')],
      ['', 'A jogosultság első napja', ertek(datum(jog.datum))],
      ['', 'Irányadó időszak', ertek(igN >= tolN ? `${datum(tolN)} – ${datum(igN)}` : 'nincs (a biztosítás az irányadó időszak vége után kezdődött)')],
      ['', 'Szerződés szerinti havi jövedelem a jogosultság első napján (Ft)', ertek(ber.osszeg ? `${ft(ber.osszeg)}${ber.megj ? ` (${ber.megj})` : ''}` : '')],
    ])}
    <h2>Az irányadó időszak jövedelmei</h2>
    ${adatTabla(['Időszak', 'Kieső napok', 'Jövedelemmel ellátott napok', 'NAV-hoz bevallott jövedelem (Ft)'], sorok, [1, 2, 3],
      sorok.length ? ['Összesen', osszKieso ? String(osszKieso) : '', String(osszNap), ft(osszJov)] : undefined)}
    <div class="megj">Kieső nap: táppénz, fizetés nélküli szabadság (a jelenléti nyilvántartásból). A jövedelem a havi járulékalap (08-as bevallás).</div>
    ${n180 ? `<h2>Tájékoztató számítás</h2>${rovatok([
      ['', n180 >= 180 ? 'Az irányadó időszak végéről visszafelé legalább 180 naptári nap jövedelme' : `Jövedelemmel ellátott napok (${n180} nap – 180 napnál kevesebb)`, `<b>${ft(j180)} Ft / ${n180} nap</b>`],
      ['', 'Egy naptári napra jutó jövedelem', `<b>${ft(j180 / n180)} Ft</b>`],
    ])}<div class="megj">A táppénz napi összegét a kormányhivatal állapítja meg (Ebtv. 48. §: 180 napi jövedelem, ennek hiányában a szerződés szerinti jövedelem; 60%, két évnél rövidebb folyamatos biztosításnál 50%, felső határ a minimálbér kétszeresének harmincad része).</div>` : ''}
    ${alairas()}
  </div>`;
}

/* ─────────── 3. TÁPPÉNZIGÉNYLŐ – EB_IGBEJ_01 kitöltő lap ─────────── */

const IGBEJ_JOGVISZONY: Record<string, string> = {
  munkaviszony: '1 – munkaviszony', egyeni_vallalkozo: '2 – főfoglalkozású / 3 – mellékfoglalkozású egyéni vállalkozó',
  tarsas_vallalkozo: '5 – főfoglalkozású / 6 – mellékfoglalkozású társas vállalkozó', megbizas: '10 – munkavégzésre irányuló egyéb jogviszony',
  vezeto: '10 – munkavégzésre irányuló egyéb jogviszony', egyeb: '',
};
const KK_KODOK = '1 üzemi baleset · 2 foglalkozási megbetegedés · 3 közúti baleset · 4 egyéb baleset · 5 beteg gyermek ápolása · 7 közegészségügyi eltiltás / hatósági elkülönítés · 8 egyéb keresőképtelenség · 9 veszélyeztetett várandósság';
const JOV_NELKULI = '1 táppénz · 2 GYÁP · 3 baleseti táppénz · 4 CSED · 5 GYED · 6 örökbefogadói díj · 7 igazolatlan távollét · 8 fizetés nélküli szabadság · 9 igazolt, nem fizetett távollét · 10 GYES · 11 GYET · 12 ápolási díj · 13 gyermekek otthongondozási díja · 14 sztrájk · 15 letartóztatás · 16 szabadságvesztés · 17 munkavégzési kötelezettség alóli mentesítés · 18 egyéni vállalkozás szüneteltetése · 19 önkéntes tartalékos szolgálat';

function hoKeresokeptelensegei(d: any, ev: number, ho: number, napiOra: number) {
  const tol = iso(ev, ho, 1), ig = iso(ev, ho, honapNapjai(ev, ho));
  return keresokeptelensegek(d, napiOra).filter((k) => k.ig >= tol && k.tol <= ig);
}
const ksSorok = (l: { tol: string; ig: string }[]) => (l.length ? adatTabla(['Időszak -tól', '-ig', 'Kód', 'Kórházi'], l.map((k) => [datum(k.tol), datum(k.ig), '', '']))
  : `<div>tól: ${pont(30)} ig: ${pont(30)} kód: ${pont(10)} kórházi: ${pipa(false)}</div>`);
const igenNem = (v: boolean | null) => `${pipa(v === true)}igen &nbsp; ${pipa(v === false)}nem`;

export function tappenzIgeny(u: any, d: any, ev: number, ho: number, fo: any): string {
  const a = d.alkalmazott;
  const j = fo;
  const napiOra = n(j?.napi_oraszam) || 8;
  const kk = hoKeresokeptelensegei(d, ev, ho, napiOra);
  const elso = kk[0] || null;
  const utolso = kk[kk.length - 1] || null;
  const ment = elso ? mentesulesek(d, elso.tol, utolso!.ig) : [];
  const hiany: string[] = [];
  if (u.kifizetohelyi) hiany.push('A foglalkoztató társadalombiztosítási kifizetőhely – a táppénzt maga állapítja meg; az EB_IGBEJ_01-et csak külön esetekben (pl. megszűnt jogviszony, méltányosság) nyújtja be.');
  if (!kk.length) hiany.push(`${ev}. ${HONAPNEV[ho - 1]} hónapban nincs rögzített betegnap (Számfejtés › Béradatok › Jelenlét) – a keresőképtelenség adatai kitöltendők.`);
  const ber = haviBer(j);
  const kedv = (d.kedvezmenyek || []).filter((k: any) => (!k.ervenyes_ig || k.ervenyes_ig >= `${ev}-01-01`) && (!k.ervenyes_tol || k.ervenyes_tol <= `${ev}-12-31`));
  const tartas = (d.letiltasok || []).filter((l: any) => l.aktiv && /tart/i.test(String(l.tipus || '')));
  //  17.10–12.: a tárgyév és az előző év jövedelemmel el nem látott időszakai – a mostani keresőképtelenség előtt.
  const jovNelkul = jelMind(d).filter((x: any) => (x.ev === ev || x.ev === ev - 1) && ho6(x.ev, x.ho) < ho6(ev, ho) && (n(x.tappenz_napok) > 0 || n(x.fizetes_nelkuli_orak) > 0))
    .map((x: any) => `${x.ev}. ${HONAPNEV[x.ho - 1]}: ${[n(x.tappenz_napok) ? `táppénz (1) ${n(x.tappenz_napok)} nap` : '', n(x.fizetes_nelkuli_orak) ? `fizetés nélküli szabadság (8) ${Math.round(n(x.fizetes_nelkuli_orak) / napiOra)} nap` : ''].filter(Boolean).join(', ')}`);
  const elsoNapStatusz = elso ? napTerkep(d)[elso.tol] : null;
  return `${STILUS}<div class="tb">
    <h1>Igénybejelentés egészségbiztosítási pénzbeli ellátásra – táppénz</h1>
    <div class="alcim">EB_IGBEJ_01 kitöltő lap – az űrlap a SZÜF-ön (Cégkapu / Hivatali Kapu) nyújtható be, a kérelem átvételétől számított 5 napon belül, a székhely szerinti kormányhivatalhoz (217/1997. Korm. r. 38. §)</div>
    ${nemHivatalos('Kitöltő lap az elektronikus űrlaphoz, az űrlap rovatszámaival, a bérnyilvántartásból előtöltve. Nem nyújtható be; az orvosi (kórházi) igazolásokat az űrlaphoz szkennelve kell csatolni.')}
    ${figy(hiany)}
    <h2>Előlap</h2>
    ${rovatok([
      ['', 'Foglalkoztató neve, adószáma', ertek([u.hivatalos_nev || u.nev, u.adoszam].filter(Boolean).join(', '))],
      ['', 'Foglalkoztató székhelye', ertek(u.cim)],
      ['2.1.', 'Kinek a kérelme', '<b>2 – foglalkoztatónál alkalmazott</b>'],
      ['2.3.', 'Kérelmező: TAJ, név, születési név', ertek([a.taj, a.nev, a.szuletesi_nev && a.szuletesi_nev !== a.nev ? `szül.: ${a.szuletesi_nev}` : ''].filter(Boolean).join(', '))],
      ['', 'Anyja neve, születési hely és idő', ertek([a.anyja_neve, a.szul_hely, a.szul_ido ? datum(a.szul_ido) : ''].filter(Boolean).join(', '))],
      ['', 'Adóazonosító jel, állandó lakcím', ertek([a.adoazonosito, a.cim].filter(Boolean).join(', '))],
    ])}
    <h2>Kérelem</h2>
    ${rovatok([
      ['1.', 'A biztosítási jogviszony típusa', ertek(IGBEJ_JOGVISZONY[j?.tipus] || '')],
      ['2.', 'Igényelt ellátás', '<b>1 – táppénz</b>'],
      ['4.', 'Folyósítás bankszámlára (számlaszám)', a.bankszamla ? `<b>igen – ${esc(bankszamla(a.bankszamla))}</b>` : `${igenNem(null)} ${pont(40)}`],
      ['5.1.', 'A biztosított jelenlegi biztosítási jogviszonyának kezdete', ertek(j?.kezdet ? datum(j.kezdet) : '')],
      ['5.2.', 'A biztosítási jogviszony megszűnésének napja', ertek(j?.veg ? datum(j.veg) : '— (fennáll)')],
      ['6.1.', 'A keresőképtelenség első napja', ertek(elso ? datum(elso.tol) : '')],
    ])}
    <div style="margin:3pt 0 2pt"><b>6.2.</b> A keresőképtelenség időszakai (az orvosi igazolás szerint – kód és kórházi jelölés az igazolásról)</div>
    ${ksSorok(kk)}
    <div class="megj">Kódok: ${esc(KK_KODOK)}</div>
    ${rovatok([
      ['6.3.', 'Továbbra is keresőképtelen?', igenNem(null)],
      ['6.5.', 'A beosztás szerinti napi munkaidő, ha a keresőképtelenség első napján munkát végzett (óra)', elsoNapStatusz === 3 ? '— (nem dolgozott)' : ertek(j ? String(napiOra) : '', 15)],
      ['6.6.', 'Ebből a ledolgozott órák száma', elsoNapStatusz === 3 ? '—' : pont(15)],
      ['6.7.', 'A keresőképtelenség alatt mentesült-e a munkavégzés alól más okból (szabadság, fizetés nélküli szabadság), ill. szünetelt-e a biztosítása', elso ? igenNem(ment.length > 0) : igenNem(null)],
      ['6.8.', 'Ennek időszakai', ment.length ? `<b>${esc(ment.map((m) => `${datum(m.tol)} – ${datum(m.ig)} (${m.jogcim})`).join('; '))}</b>` : '—'],
      ['6.9.', 'A betegszabadság utolsó napja (munkaviszonynál; 5-ös, 7-es és 9-es kódnál nem kell)', ertek(elso?.betegszabIg ? datum(elso.betegszabIg) : (elso ? '— (a betegszabadság-keret elfogyott)' : ''))],
      ['17.1.', 'Folytatott-e keresőtevékenységet a keresőképtelenség alatt', igenNem(null)],
      ['17.3.', 'A szerződés szerinti havi jövedelem a jogosultság első napján (munkaviszonynál a távolléti díj havi összege, Ebtv. 5/C. § b) (Ft)',
        ber.osszeg ? `<b>${ft(ber.osszeg)}</b><div class="megj">az alapbér${ber.megj ? ` (${esc(ber.megj)})` : ''} – a távolléti díjjal (pótlékátlag) egyeztetendő</div>` : pont()],
      ['17.5.', 'Az elmúlt két évben nappali tagozatos tanuló volt-e', igenNem(null)],
      ['17.6.', 'Adó- és járulékkedvezményt érvényesít-e (a tárgyévi nyilatkozat alapján)', igenNem(kedv.length ? true : null)],
      ['17.7.', 'A kedvezmény fajtája', kedv.length ? `<b>${esc(kedv.map((k: any) => felirat('kedvezmenyTipus', k.tipus)).join('; '))}</b>` : '—'],
      ['17.9.', 'A kérelem átvételének napja a foglalkoztatónál', pont(30)],
      ['17.10.', 'Volt-e jövedelemmel el nem látott időszak a tárgyévben vagy az előző évben', igenNem(jovNelkul.length ? true : null)],
      ['17.11–12.', 'Ennek időszaka és jogcíme', jovNelkul.length ? `<b>${esc(jovNelkul.join('; '))}</b>` : '—'],
      ['18.', 'Tartásdíj-levonás fennáll-e (mérték, jogosult)', tartas.length ? `<b>igen – ${esc(tartas.map((l: any) => [l.jogosult, l.szazalek != null ? `${l.szazalek}%` : (l.fix_osszeg != null ? `${ft(l.fix_osszeg)} Ft/hó` : '')].filter(Boolean).join(', ')).join('; '))}</b>` : igenNem(false)],
      ['19.', 'Részesül-e valaki a gyermek után ellátásban (CSED, GYED, GYES …)', igenNem(null)],
    ])}
    <div class="megj">A jövedelemmel el nem látott időszak jogcímkódjai: ${esc(JOV_NELKULI)}.</div>
    ${alairas()}
  </div>`;
}

/* ─────────── 4. FOLYAMATOS KERESŐKÉPTELENSÉG – EB_FOLYKK_01 kitöltő lap ─────────── */

export function folyamatosKeresokeptelenseg(u: any, d: any, ev: number, ho: number, fo: any): string {
  const a = d.alkalmazott;
  const napiOra = n(fo?.napi_oraszam) || 8;
  const kk = hoKeresokeptelensegei(d, ev, ho, napiOra);
  const hoIg = iso(ev, ho, honapNapjai(ev, ho));
  const ment = kk.length ? mentesulesek(d, kk[0].tol, kk[kk.length - 1].ig) : [];
  //  Az utolsó jelölt munkanapig tartó betegség valószínűleg folytatódik – csak jelzés, a választ az igazolás adja.
  const t = napTerkep(d);
  let utolsoMunkanap = '';
  for (let dt = hoIg; dt >= iso(ev, ho, 1); dt = napPlusz(dt, -1)) if (t[dt]) { utolsoMunkanap = dt; break; }
  const folytatodik = !!kk.length && kk[kk.length - 1].ig === utolsoMunkanap;
  const hiany: string[] = [];
  if (!kk.length) hiany.push(`${ev}. ${HONAPNEV[ho - 1]} hónapban nincs rögzített betegnap – a keresőképtelenségi időszakok kitöltendők.`);
  if (folytatodik) hiany.push('A betegség a hónap utolsó jelölt napjáig tart – a 2.1. pont valószínűleg „igen” (az orvosi igazolás szerint).');
  return `${STILUS}<div class="tb">
    <h1>Adatlap folyamatos keresőképtelenség igazolásához</h1>
    <div class="alcim">EB_FOLYKK_01 kitöltő lap – ha a táppénzkérelmet már benyújtották, és a biztosított továbbra is keresőképtelen; a SZÜF-ön, 5 napon belül, a székhely szerinti kormányhivatalhoz</div>
    ${nemHivatalos('Kitöltő lap az elektronikus űrlaphoz, az űrlap rovatszámaival, a bérnyilvántartásból előtöltve. Az újabb orvosi (kórházi) igazolásokat az űrlaphoz kell csatolni.')}
    ${figy(hiany)}
    ${rovatok([
      ['1.3.', 'Foglalkoztató rövid neve, adószáma', ertek([u.nev, u.adoszam].filter(Boolean).join(', '))],
      ['1.4.', 'Foglalkoztató székhelye', ertek(u.cim)],
      ['', 'Igényelt ellátás', '<b>1 – táppénz</b>'],
      ['1.5.', 'Eljáró kormányhivatal (a székhely szerinti vármegyei / fővárosi kormányhivatal)', pont(55)],
      ['1.6.', 'Ügyazonosító („1-” kezdetű, az EB_IGBEJ_01 visszaigazolásából; régi ÁNYK-s előzménynél 0)', pont(45)],
      ['1.7.', 'Kérelmező: TAJ, név, születési név', ertek([a.taj, a.nev, a.szuletesi_nev && a.szuletesi_nev !== a.nev ? `szül.: ${a.szuletesi_nev}` : ''].filter(Boolean).join(', '))],
      ['', 'Anyja neve, születési hely és idő', ertek([a.anyja_neve, a.szul_hely, a.szul_ido ? datum(a.szul_ido) : ''].filter(Boolean).join(', '))],
    ])}
    <h2>2.0. A keresőképtelenségre vonatkozó adatok – ${ev}. ${HONAPNEV[ho - 1]}</h2>
    ${ksSorok(kk)}
    <div class="megj">Kódok: ${esc(KK_KODOK)}</div>
    ${rovatok([
      ['2.1.', 'Továbbra is keresőképtelen?', igenNem(null)],
      ['3.1.', 'A keresőképtelenség alatt folytat(ott) keresőtevékenységet? (ha igen: tól–ig)', igenNem(null)],
      ['3.2.', 'A keresőképtelenség alatt más okból mentesült a munkavégzés alól (szabadság, fizetés nélküli szabadság), vagy szünetelt a biztosítása?', kk.length ? igenNem(ment.length > 0) : igenNem(null)],
      ['3.3.', 'A mentesülés időtartama', ment.length ? `<b>${esc(ment.map((m) => `${datum(m.tol)} – ${datum(m.ig)} (${m.jogcim})`).join('; '))}</b>` : '—'],
    ])}
    ${alairas()}
  </div>`;
}
